import { Box } from '@mui/material';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import { Source, SOURCE_ANSWERS } from '../../../providers/QuizProvider/QuizProvider.types';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import QuizContainer from '../../common/QuizContainer';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step19() {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: Source) => {
    setQuizData((prev) => ({
      ...prev,
      source: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={19}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="Where did you hear about us?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(SOURCE_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof SOURCE_ANSWERS)}
              variant={ButtonType.WHITE}
              text={SOURCE_ANSWERS[key as keyof typeof SOURCE_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step19;
